import { render, staticRenderFns } from "./DefaultCurrency.vue?vue&type=template&id=1a01ad11&scoped=true"
import script from "./DefaultCurrency.vue?vue&type=script&lang=js"
export * from "./DefaultCurrency.vue?vue&type=script&lang=js"
import style0 from "./DefaultCurrency.vue?vue&type=style&index=0&id=1a01ad11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a01ad11",
  null
  
)

export default component.exports